// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "network.trustkeys",
    name: "TK Finance",
    homepage: "https://trustkeys.network/",
    image_id: "c4066f68-2247-49bf-ac8a-a677bfa81800",
    app: {
        browser: null,
        ios: "https://apps.apple.com/vn/app/tk-finance/id1601968967",
        android: "https://play.google.com/store/apps/details?id=com.trustkeysnetwork",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "tk://",
        universal: "https://trustkeys.network",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map